<div
  class="document-upload__dropzone"
  [ngClass]="{
    'is-disabled': disabled,
    horizontal__dropzone: fileUploadAlignment,
  }"
>
  @if (fileUploadText) {
    <p
      class="document-upload__dropzone__text"
      [ngClass]="{ 't-alt': disabled }"
    >
      {{ fileUploadText }}
    </p>
  } @else {
    Drag and drop files or
  }
  <ng-content></ng-content>
</div>
